import Test from '@/models/Test';

const GET_TESTS = 'get_tests';
const GET_TESTS_REQUEST = 'get_tests_request';
const GET_TESTS_SUCCESS = 'get_tests_success';
const GET_TESTS_ERROR = 'get_tests_error';

export { GET_TESTS };

export default {
    state: {
        tests: [],
        loading: false,
        testsErrors: [],
    },
    mutations: {
        [GET_TESTS_REQUEST]: (state) => {
            state.tests = [];
            state.loading = true;
            state.testsErrors = [];
        },
        [GET_TESTS_SUCCESS]: (state, { tests }) => {
            state.tests = tests;
            state.loading = false;
            state.testsErrors = [];
        },
        [GET_TESTS_ERROR]: (state, { errors }) => {
            state.tests = [];
            state.loading = false;
            state.testsErrors = errors;
        },
    },
    actions: {
        [GET_TESTS]: ({ commit, rootState }, { trajectoryId, params = {} }) => {
            if (!trajectoryId) {
                trajectoryId = rootState.trajectory.trajectory.id;
            }
            commit(GET_TESTS_REQUEST);
            return new Promise((resolve, reject) => {
                const TrajectoryTests = Test.makeModel(`/trajectories/${trajectoryId}/tests`);
                TrajectoryTests.collection(params)
                    .then(({items, meta}) => {
                        const tests = items;
                        commit(GET_TESTS_SUCCESS, { tests });
                        resolve(items);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_TESTS_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/tests.js